import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { Button } from "../shadcn/button";
import { copyToClipboard } from "@/utils/generic";

interface CopyableUrlFieldProps {
  label?: string;
  url: string;
  description?: string;
}

export const CopyableUrlField = ({
  label,
  url,
  description,
}: CopyableUrlFieldProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    copyToClipboard(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      {label && <p className="text-sm font-medium mb-1">{label}</p>}
      {description && (
        <p className="text-xs text-muted-foreground mb-2">{description}</p>
      )}
      <div className="flex items-center gap-2">
        <p className="text-xs border rounded-md px-3 py-2 grow truncate shadow-xs bg-muted/30 text-muted-foreground font-mono">
          {url}
        </p>
        <Button
          type="button"
          variant="outline"
          className="flex-shrink-0 h-8 w-8"
          size="icon"
          onClick={handleCopy}
        >
          {copied ? (
            <Check className="w-3.5 h-3.5" />
          ) : (
            <Copy className="w-3.5 h-3.5" />
          )}
        </Button>
      </div>
    </div>
  );
};
